import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth, useDroits } from './auth';
import Layout from './components/Layout';
import { Chargement } from './components/ui';
import Connexion from './pages/Connexion';
import TableauDeBord from './pages/TableauDeBord';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Postes from './pages/Postes';
import PosteDetail from './pages/PosteDetail';
import Logiciels from './pages/Logiciels';
import MisesAJour from './pages/MisesAJour';
import Historique from './pages/Historique';
import Utilisateurs from './pages/Utilisateurs';

function Routage() {
  const { utilisateur, verification } = useAuth();
  const { superAdmin } = useDroits();

  if (verification) return <div className="page-connexion"><Chargement /></div>;
  if (!utilisateur) return <Connexion />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<TableauDeBord />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="postes" element={<Postes />} />
        <Route path="postes/:id" element={<PosteDetail />} />
        <Route path="logiciels" element={<Logiciels />} />
        <Route path="mises-a-jour" element={<MisesAJour />} />
        <Route path="historique" element={<Historique />} />
        {superAdmin && <Route path="utilisateurs" element={<Utilisateurs />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routage />
      </BrowserRouter>
    </AuthProvider>
  );
}
